import React, { useEffect } from "react";
import { user } from "../../atom";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios, { socket } from "../../axios";
import { useRecoilState } from "recoil";
export default function () {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useRecoilState(user);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let token = localStorage.getItem("token");
      try {
        if (!token) navigate("/registry/login");
        let res = await axios.post("/api/auth/token", null, {
          headers: { Authorization: `Bearere ${token}` },
        });
        socket
          .connect()
          .off("new-user")
          .on("new-user", (members) => console.log(members));
        setCurrentUser(res.data);
        setLoading(false);
        socket.disconnect();
      } catch (err) {
        console.log(err.response);
      }
    };
    fetchData();
  }, []);
  return <div></div>;
}
